import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_Cheques, inicializar_Cheques } from '../../actions/clientes/act_cli03';
import { validarFechaMomentEnFormatoString, validarJSON } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String,  formatearFechaMoment_a_StringFormatoReporte, formatearNumeroDecimal } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf,generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';

import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';

import {  getItemDatosSesion } from '../../funciones_globales/manejosesion';

const COD_BOTON_EXCEL= '010201';
class FormCli03 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      isVisibleBotonExcel:false,
      cheques: [],      
      fechaVctoChequeDesde: null,
      fechaVctoChequeHasta: null,
      cliente_sel: null,
      totalCheques: 0,
      
      columnsDefGridCheques: [
        { header: "No.",
          field: "Secuencia",
          width: 30,
          type: "string",
          suppressFilter: true
        },
        { header: "F. Cheque",
          field: "FechaCheque",
          width: 85,
          type: "string"
        },
        { header: "F. Vcto.",
          field: "FechaVcto",
          width: 85,
          type: "string"
        },
        { header: "F. Ingreso",
          field: "Fecha",
          width: 85,
          type: "string"
        },
        { header: "Banco",
          field: "Banco",
          width: 135,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 95,
          type: "string"
        },
        { header: "No. Cheque",
          field: "Cheque",
          width: 85,
          type: "string"
        },
        { header: "Cliente",
          field: "Cliente",
          width: 210,
          type: "string"
        },        
        { header: "Estado",
          field: "Estado",
          width: 70,
          type: "string"
        },            
        { header: "Caja",
          field: "Caja",
          width: 70,
          type: "string",
          suppressFilter: true
        },
        { header: "Mov. Caja",
          field: "Movimiento",
          width: 90,
          type: "string"
        },
        { header: "Valor",
          field: "Valor",
          width: 90,
          type: "num_decimal",
          filter: "number"
        }
      ],
    };

    this.gridChequesOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true      
    };
    
    this.onGridChequesReady = this.onGridChequesReady.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cargarCheques = this.cargarCheques.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.generarReporteCartera = this.generarReporteCartera.bind(this);
    this.generarReporteCarteraExcel = this.generarReporteCarteraExcel.bind(this);
    
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onGridChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }
  
  componentDidMount(){
    let usuario = getItemDatosSesion('usuario');
    
    Promise.all([
        cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
      ])
    .then(([ configBotonExcel ]) => {
        this.props.generar_LogAuditoriaIngresoForm('0103');
        this.props.inicializar_Cheques();
        let isVisibleBotonExcel = false;

        if(configBotonExcel.display==='block'){
            isVisibleBotonExcel = true;
        }
        this.setState({ 
            isVisibleBotonExcel
        });
    })
    .catch(error => {
        alert(error);
    });
    this.props.generar_LogAuditoriaIngresoForm('0103');
    this.props.inicializar_Cheques();
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0103');
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = '?tipo=catalogo&cadena_busq=' + input;     
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  limpiar(){    
    this.setState({
      cheques: [],
      fechaVctoChequeDesde: null,
      fechaVctoChequeHasta: null,
      cliente_sel: null,
      totalCheques: 0
    });
    this.props.inicializar_Cheques();
  }

  cargarCheques(){    
    let fechaVctoChequeDesde = formatearFechaMoment_a_String(this.state.fechaVctoChequeDesde);
    let fechaVctoChequeHasta = formatearFechaMoment_a_String(this.state.fechaVctoChequeHasta);
    
    if (!validarFechaMomentEnFormatoString(fechaVctoChequeDesde)){
      alert('El campo Fecha Vencimiento Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeHasta)){
      alert('El campo Fecha Vencimiento Hasta es inválido.');
      return;
    }

    if(this.state.fechaVctoChequeHasta.diff(this.state.fechaVctoChequeDesde, 'days')<0){
      alert('La fecha Fecha Vencimiento Desde no puede ser mayor que Fecha Vencimiento Hasta.');
      return;
    }

    let codCliente = this.state.cliente_sel===null?'':this.state.cliente_sel;
    
    this.props.inicializar_Cheques();
    this.props.cargar_Cheques('P', fechaVctoChequeDesde, fechaVctoChequeHasta, codCliente)
    .then(()=>{
      try {
        let cheques = [];
        let totalCheques = 0;

        this.props.cheques.forEach((item, i)=>{
          cheques.push({
            Secuencia: (i+1),
            FechaCheque: item.FechaCheque,
            FechaVcto: item.Vencimiento,
            Fecha: item.Fecha,
            Banco: validarJSON(item.banco)?`${item.banco.Codigo} - ${item.banco.Descripcion}`:'',
            Cuenta: item.Cuenta,
            Cheque: item.Cheque,
            Cliente: validarJSON(item.cli)?`${item.cli.Codigo} - ${item.cli.Nombre}`:'',
            Estado: item.Status,          
            Caja: item.Caja,
            Movimiento: item.Movimiento,
            Valor: item.Valor,
            Procedencia: 'C'
          });

          totalCheques += parseFloat(item.Valor===null?0:item.Valor);
        });

        this.setState({cheques, totalCheques});
      } catch (error) {
        alert(`Ocurrió un error al cargar los cheques. Error: ${error}`);
      }
    });
  }

  generarReporteCartera(){
    let fechaVctoChequeDesde = formatearFechaMoment_a_String(this.state.fechaVctoChequeDesde);
    let fechaVctoChequeHasta = formatearFechaMoment_a_String(this.state.fechaVctoChequeHasta);

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeDesde)){
      alert('El campo Fecha Vencimiento Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeHasta)){
      alert('El campo Fecha Vencimiento Hasta es inválido.');
      return;
    }

    if(this.state.fechaVctoChequeHasta.diff(this.state.fechaVctoChequeDesde, 'days')<0){
      alert('La fecha Fecha Vencimiento Desde no puede ser mayor que Fecha Vencimiento Hasta.');
      return;
    }

    let filtrosReporte = '&rpt=8&param1=' + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaVctoChequeDesde);
    filtrosReporte += '&param2=' + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaVctoChequeHasta);
    
    if(this.state.cliente_sel!==null){
      filtrosReporte += `&param3=${this.state.cliente_sel}`;
    }    

    visualizarReporteEnPdf(filtrosReporte);  
  }
  generarReporteCarteraExcel(){
    let fechaVctoChequeDesde = formatearFechaMoment_a_String(this.state.fechaVctoChequeDesde);
    let fechaVctoChequeHasta = formatearFechaMoment_a_String(this.state.fechaVctoChequeHasta);

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeDesde)){
      alert('El campo Fecha Vencimiento Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeHasta)){
      alert('El campo Fecha Vencimiento Hasta es inválido.');
      return;
    }

    if(this.state.fechaVctoChequeHasta.diff(this.state.fechaVctoChequeDesde, 'days')<0){
      alert('La fecha Fecha Vencimiento Desde no puede ser mayor que Fecha Vencimiento Hasta.');
      return;
    }

    let filtrosReporte = '&rpt=127&param1=' + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaVctoChequeDesde);
    filtrosReporte += '&param2=' + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaVctoChequeHasta);
    
    if(this.state.cliente_sel!==null){
      filtrosReporte += `&param3=${this.state.cliente_sel}`;
    }    
    generarReporteEnExcel(filtrosReporte);
  }

  render(){
    return(      
      <ContenedorForm porc_ancho={85}>
        <HeaderForm>
          <TituloForm>Cartera de cheques</TituloForm>
        </HeaderForm>
        <CuerpoForm>
            <Row>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Fecha Vcto. (Desde):</LabelForm>                
                <PickerFecha fechaSeleccionada={this.state.fechaVctoChequeDesde} 
                  func_onChange={(fecha)=>{this.setState({fechaVctoChequeDesde: fecha})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Fecha Vcto. (Hasta):</LabelForm>
                <PickerFecha fechaSeleccionada={this.state.fechaVctoChequeHasta} func_onChange={(fecha)=> { this.setState({fechaVctoChequeHasta: fecha})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-4'>
                <LabelForm>Cliente:</LabelForm>
                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({cliente_sel: value===null?null:value.value})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-1'>
                <ContenedorBoton margen_arriba={20}>
                  <Tooltip placement="right" overlay='Buscar cheques'>
                    <button type='button' className='btn btn-success btn-sm' onClick={this.cargarCheques}><i className='fa fa-search'></i></button>
                  </Tooltip>
                </ContenedorBoton>
              </ContainerCol>                
            </Row>            
            <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='400px' data={this.state.cheques} columnas={this.state.columnsDefGridCheques}
                    gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
                </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-offset-8 col-sm-2'>
                  <LabelForm>{`No. Reg.: ${this.state.cheques.length}`}</LabelForm>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <span className='pull-right'>
                  <LabelForm>{`Total: ${formatearNumeroDecimal(this.state.totalCheques)}`}</LabelForm>
                </span>
              </ContainerCol>
            </Row>
            <Row margen_arriba={10}>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>                  
                  <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteCartera}><i className='fa fa-print fa-lg'/> Imprimir Pdf</button>
                  {
                    this.state.isVisibleBotonExcel?
                      <button type='button' className='btn btn-success btn-sm' onClick={this.generarReporteCarteraExcel}><i className='fa fa-print fa-lg'/> Imprimir Excel</button>
                      :null
                  }
                 
                  <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                </div>
              </div>
            </Row>
        </CuerpoForm>
      </ContenedorForm>
    )
  }  
}

const mapStateToProps = state =>{
  return {  cheques: state.clientes.cheques };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cargar_Cheques,
                              cambiar_VisualizacionLoading, inicializar_Cheques }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli03);